<template>
  <router-view v-wechat-title="$route.meta.title"></router-view>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    //地址栏获取是否支付成功
    // if(this.$util.getHashParam('paySuc') && this.$util.getHashParam('payBillId')) {
    //   this.payBillId = this.$util.getHashParam('payBillId')
    // }
  },
  data() {
    return {
      payBillId:''
    }
  },
  methods:{
  }
}
</script>

<style>

</style>
